import { ShortCode } from './short-code';
import { After, Before } from './util';
import { Multicountry } from '../../../../../../shared/interfaces/create-surveys.interface';

export class SortCountryLang {
  constructor(
    public readonly countryList: Multicountry[],
    public readonly countryShortCode: string,
    public readonly languageShortCode: string
  ) {}

  sort() {
    return [
      ...this.countryList.sort((a, b) => {
        if (
          (new ShortCode(b).value() == this.countryShortCode &&
            b.language.short_code == this.languageShortCode) ||
          new ShortCode(a).value() != this.countryShortCode
        ) {
          return new After().values();
        }

        return new Before().values();
      }),
    ];
  }
}
